var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"clearfix"},[_c('Board',{staticStyle:{}}),_c('Login',{staticStyle:{"float":"right"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }